import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

import Configurer from "../../components/Configurer";
import StagesManager from "../../components/StagesManager";
import { checkTranslation, conditionalWidth, imageAddress, pathMaker, translate } from "../../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../../components/PageStatusViewer";

// import AdminDashboard from "../admin/AdminDashboard";
// import AdminFormApplet from "../admin/AdminFormApplet";
// import AdminBoxesApplet from "../admin/AdminBoxesApplet";
import { AutomationsPages } from "../../variables/AppletPages";
// import AppletDashboardView from "./views/AppletDashboardView";
import { Link } from "react-router-dom";
import TLink from "../../components/TLink";
// import AdminSettings from "../admin/AdminSettings";

import BoxesView from "../../components/views/BoxesView";
import FormView from "../../components/views/FormView";
import DashboardView from "../../components/views/DashboardView";
import SettingsView from "../../components/views/SettingsView";
import Responsive from "../../components/Responsive";
import Collapsible from "react-collapsible";
import Warehouse from '../../components/views/Warehouse';
import AddRuleView from '../../components/views/AddRuleView';
// export default class AutomationsApplet extends Component {
class AutomationsApplet extends React.Component {

    state = {
        modules: [],
        collapses: {},

    }


    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = Object.values(AutomationsPages.pages)
                let accessSections = Object.values(AutomationsPages.sections)
                console.log(accessPages)
                this.setState({ modules: accessPages, sections: accessSections }, () => {
                    this.checkDefaultTab()

                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]


        if ((this.state.oldData && this.state.oldData != this.props.windowData)) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }



    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]
        pathname.forEach((path, index) => {
            if (path == (rootRef)) {
                def = pathname[index + 1]
            }
        });

        // console.log(this.props.route)


        let pageIsValid = false
        // let accessPages = Object.values(SettingsPages.pages)

        Object.values(this.state.modules).forEach(page => {

            let defaultPage = page.defaultPage
            if (conditionalWidth(this.props.width, { xs: true, sm: false })) {
                defaultPage = false
            }
            // console.log(def)
            // console.log(((def==''|| !def) && page.defaultPage))
            if ((page.key && page.key.toLowerCase() === def?.toLowerCase()) || ((def == '' || !def) && defaultPage)) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page

                if ((def == '' || !def)) {
                    def = page?.key
                    this.changePage(page?.key)
                }
            }

        });
        if (!def) {
            def = ''
        }



        // return
        // console.log(def)
        // return
        if (def === '') {
            pageType = ''
            pageIsValid = true
            // this.changePage('general')

        }
        if (pageIsValid) {

            // this.state.page = page
            // console.log(pageType)

            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {

                            this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }



    changePage = (page) => {

        let path
        if (page) {
            path = [page?.key ?? page]
        }
        // console.log(path)
        this.props.changeWindowLink(path)

    }



    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }

    scrollTo = (type) => {
        if (type == 'bottom') {
            this.pageContainer.scrollTo({ top: this.pageContainer.scrollHeight, behavior: 'smooth' })
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'AutomationsApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    render() {
        let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub
        let variables = {
            appletId: this.props.applet?._id,
            appletHub: appletHub
        }

        // console.log(variables)
        return (
            <div className='d-flex w-100 h-100'>

                {(conditionalWidth(this.props.width, { xs: false, sm: true }) || !this.state.page) && (
                    <Responsive height="100%" width={this.props.width} media={{ xs: "12", sm: '28%', md: '28%', lg: "28%", xl: "20%" }}>

                        <div className='scroll-no-scrollbar h-100 pt-3 pb-4 w-100 d-flex flex-column text-start' >
                            <div>
                                <div onClick={() => this.props.goToHub()} className='flexc pb-3 px-3 cursor-pointer' style={{ borderBottom: '1px solid #eee' }}>
                                    <img src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width="40px" style={{ height: 40, objectFit: 'cover', borderRadius: 100 }} />
                                    <div className='mld-2'>
                                        <h2 className="m-0 text-normal mb-0" >{checkTranslation(this.props.applet?.hub?.fullname)}</h2>
                                        <div style={{ maxWidth: 450 }}>
                                            <p className="mt-0 text-small color-gray-1" >{translate('Commerce')}</p>
                                        </div>
                                    </div>
                                </div>


                                <div className="mt-0">

                                    <button onClick={() => this.changePage('')} className='flexc w-100 pb-3 pt-3 px-3 cursor-pointer transition-all' style={{ backgroundColor: this.state.page?.key == null ? '#eee' : '' }}>
                                        <div className="flexc">
                                            <img className="transition-all" src={'/assets/icons/applets/general/Asset 9.png'} height={30} style={{ filter: this.state.page?.key == null ? '' : 'saturate(0%)' }} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'text-semibold text-small text-capitalize ' + (this.state.page?.key == null ? "" : "color-gray-3")}>{translate("Dashboard")}</p>

                                            </div>
                                        </div>

                                    </button>

                                    {this.state.sections?.map((section, i) => {
                                        return (
                                            <div className="w-100 pt-3" style={{ borderTop: '1px solid #e8e8e8' }}>

                                                <button className="flexcb w-100 pb-2 m-0 px-3" style={{ backgroundColor: !this.state.collapses[section.key] ? '' : '' }} onClick={() => this.changeCollapse(section.key)}>
                                                    <div className="flexc">
                                                        {/* <img className="mld-3" src={section.icon} style={{ width: 20, height: 20, objectFit: 'contain' }} /> */}
                                                        <p className="text-small text-bold text-uppercase color-gray-3 " style={{}}>{checkTranslation(section.name)}</p>
                                                    </div>

                                                    <div className="px-2">
                                                        <img src={'/images/arrow-a.svg'} className={"transition-all " + (!this.state.collapses[section.key] ? "rotate-90" : "")} style={{ opacity: '0.3', width: 8, height: 8, objectFit: 'contain' }} />
                                                    </div>
                                                    {/* <p className="text-normal text-bold px-2" style={{ color: '#677dc470' }}>{!this.state.collapses[section.key] ? "-" : "+"}</p> */}
                                                </button>


                                                <Collapsible open={!this.state.collapses[section.key]}>

                                                    {this.state.modules.map((item, index) => {
                                                        if (section.key == item.section)
                                                            return (
                                                                <div className='w-100 ' key={index}>
                                                                    <button onClick={() => this.changePage(item)} className='flexc w-100 pb-3 pt-3 px-3 cursor-pointer transition-all' style={{ backgroundColor: this.state.page?.key == item.key ? '#eee' : '' }}>
                                                                        <div className='flexcc'>
                                                                            <img className="transition-all" src={item.icon} height={22} style={{ filter: this.state.page?.key == item.key ? '' : 'saturate(0%)' }} />
                                                                        </div>
                                                                        <div className='d-flex flex-column mld-3'>
                                                                            <p className={'text-semibold text-small text-capitalize text-start ' + (this.state.page?.key == item.key ? "" : "color-gray-3")}>{checkTranslation(item.title)}</p>
                                                                            {/* <p className='text-smallest color-gray-4'>{translate(item.description)}</p> */}

                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                    })}
                                                </Collapsible>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>

                    </Responsive>
                )}

                {(conditionalWidth(this.props.width, { xs: false, sm: true }) || this.state.page) && (

                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '72%', md: '72%', lg: "80%", xl: "80%" }}>

                        <div className="w-100 h-100 scroll-no-scrollbar  window-content-radius " ref={el => this.pageContainer = el} style={{ backgroundColor: '#fff' }} >

                            <StagesManager height={'100%'} ref={el => this.stageManager = el} fast={true} minHeight={this.props.height}>

                                <DashboardView setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} type={'Connections'} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={variables} />
                                <FormView setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'table'} route={this.props.route} variables={variables} />
                                <BoxesView setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'boxes'} route={this.props.route} variables={variables} />
                                <SettingsView setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'settings'} route={this.props.route} variables={variables} />
                                <AddRuleView setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'addRule'} route={this.props.route} variables={variables} scrollTo={this.scrollTo} />

                            </StagesManager>

                        </div>

                    </Responsive>

                )}
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomationsApplet);